import React from "react";
import { NavLink } from "react-router-dom";

interface BaseProps {
  icon: React.ReactNode;
  label: string;
  description?: string;
}

interface LinkProps extends BaseProps {
  to: string;
  onClick?: never;
  isActive?: never;
}

interface ButtonProps extends BaseProps {
  onClick: () => void;
  isActive: boolean;
  to?: never;
}

type SidebarItemProps = LinkProps | ButtonProps;

export default function SidebarItem(props: SidebarItemProps) {
  function isLinkProps(props: SidebarItemProps): props is LinkProps {
    return (props as LinkProps).to !== undefined;
  }

  const baseClasses =
    "flex items-start gap-3 w-full px-4 py-3 rounded-xl text-left transition-all duration-150 border";

  const getClasses = (isActive: boolean) =>
    `${baseClasses} ${isActive
      ? "bg-green-100 border-green-300 text-green-700"
      : "border-transparent text-gray-800 hover:bg-gray-50"
    }`;

  const renderContent = (isActive: boolean) => (
    <>
      {/* Icon */}
      <div className="mt-1 flex-shrink-0">{props.icon}</div>

      {/* Text block */}
      <div className="flex flex-col min-w-0">
        <span
          className={`truncate ${isActive ? "font-medium text-green-700" : "text-gray-800"
            }`}
        >
          {props.label}
        </span>

        {props.description && (
          <span className="text-sm text-gray-500 truncate">
            {props.description}
          </span>
        )}
      </div>
    </>
  );

  // NavLink (routing)
  if (isLinkProps(props)) {
    return (
      <NavLink to={props.to} className={({ isActive }) => getClasses(isActive)}>
        {({ isActive }) => renderContent(isActive)}
      </NavLink>
    );
  }

  // Button (manual state)
  return (
    <button onClick={props.onClick} className={getClasses(props.isActive)}>
      {renderContent(props.isActive)}
    </button>
  );
}
